import script from "./SmartHeatingEN.vue?vue&type=script&setup=true&name=Ai_platform&lang=js"
export * from "./SmartHeatingEN.vue?vue&type=script&setup=true&name=Ai_platform&lang=js"

import "./SmartHeatingEN.vue?vue&type=style&index=0&id=3ff08a66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff08a66"]])

export default __exports__